export default __webpack_public_path__ + "static/media/fleet.ff5f6118.svg";